import React from "react";
import { ReactComponent as Icon1 } from "../../img/house-icon.svg";
import { ReactComponent as Icon2 } from "../../img/auth-icon.svg";
import { ReactComponent as Icon3 } from "../../img/key-icon.svg";

const InfoBlock = ({ children, title, desc }) => {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        textAlign: "center",
      }}
    >
      <div style={{ marginBottom: "16px" }}>{children}</div>

      <h2
        style={{
          color: "#00008D",
          margin: "0 0 8px 0",
        }}
      >
        {title}
      </h2>

      {React.isValidElement(desc) ? (
        desc
      ) : (
        <p
          style={{
            color: "#000",
            margin: "0",
          }}
          className="body-lg"
        >
          {desc}
        </p>
      )}
    </div>
  );
};

const InfoBlocks = () => {
  return (
    <div className="container pt-5">
      <div className="row text-center justify-content-center">

        <div className="col-12 col-md-4 mb-4">
          <InfoBlock
            title="Kuluttaja"
            desc={
              <p
                style={{ color: "#000", marginTop: "16px", textAlign: "center" }}
                className="body-lg"
              >
                Löydä paikalliset kiinteistön- ja <br /> vuokravälitysliikkeet
              </p>
            }
          >
            <Icon1 style={{ height: "100px" }} />
          </InfoBlock>
        </div>

        <div className="col-12 col-md-4 mb-4">
          <InfoBlock
            title="Viranomainen"
            desc="Käytä välitysliikerekisteriä valvontaan"
          >
            <Icon2 style={{ height: "100px" }} />
          </InfoBlock>
        </div>

        <div className="col-12 col-md-4 mb-4">
          <InfoBlock
            title="Välitysliike"
            desc="Tarkista liikkeesi tietojen ajantasaisuus"
          >
            <Icon3 style={{ height: "100px" }} />
          </InfoBlock>
        </div>

      </div>
    </div>
  );
};

export default InfoBlocks;
